import load from 'lodash'

export const shuffledData =a=>load.shuffle(a)